module.exports = __webpack_public_path__ + "img/underline.8c3ef086.png";